import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/payments/payouts_/$payoutId_/$locationId')({
  staticData: {
    team: 'payments',
  },
});
